<div class="flex-auto p-6 sm:p-10">
    <div class="max-w-2xl prose prose-sm">
        <h1>{{ content.title }}</h1>

        <h2>{{ content.terms?.heading }}</h2>
        <p>{{ content.terms?.text }}</p>

        <h2>{{ content.useLicense?.heading }}</h2>
        <p>{{ content.useLicense?.intro }}</p>
        <ul>
            <li *ngFor="let item of content.useLicense?.restrictions">{{ item }}</li>
        </ul>
        <p>{{ content.useLicense?.outro }}</p>

        <h2>{{ content.disclaimer?.heading }}</h2>
        <p>{{ content.disclaimer?.text }}</p>

        <h2>{{ content.limitations?.heading }}</h2>
        <p>{{ content.limitations?.text }}</p>

        <h2>{{ content.revisionsAndErrata?.heading }}</h2>
        <p>{{ content.revisionsAndErrata?.text }}</p>

        <h2>{{ content.links?.heading }}</h2>
        <p>{{ content.links?.text }}</p>

        <h2>{{ content.siteTermsOfUseModifications?.heading }}</h2>
        <p>{{ content.siteTermsOfUseModifications?.text }}</p>

        <h2>{{ content.yourPrivacy?.heading }}</h2>
        <p>{{ content.yourPrivacy?.text }}</p>

        <h2>{{ content.governingLaw?.heading }}</h2>
        <p>{{ content.governingLaw?.text }}</p>
    </div>
</div>
